import React from 'react';
import 'bootstrap/dist/js/bootstrap.min';
import '../static/styles/sidebar.scss'
import $ from 'jquery';
import LodgingAPIContent from '../apis/LodgingAPIContent/LodgingAPIContent';
import CreateLodgingProducts from '../apis/LodgingAPIContent/LodgingProductAPI/CreateLodgingProducts';
import CreateLodgingProductRooms from '../apis/LodgingAPIContent/LodgingProductAPI/CreateLodgingProductRooms';
import CreateLodgingProductRatePlans from '../apis/LodgingAPIContent/LodgingProductAPI/CreateLodgingProductRatePlans';
import DeleteLodgingProduct from '../apis/LodgingAPIContent/LodgingProductAPI/DeleteLodgingProduct';
import DeleteLodgingRatePlan from '../apis/LodgingAPIContent/LodgingProductAPI/DeleteLodgingRatePlan';
import GetLodgingProductInfo from '../apis/LodgingAPIContent/LodgingProductAPI/GetLodgingProductInfo';
import UpdateLodgingProducts from '../apis/LodgingAPIContent/LodgingProductAPI/UpdateLodgingProducts';
import UpdateLodgingProductRatePlan from '../apis/LodgingAPIContent/LodgingProductAPI/UpdateLodgingProductRatePlan';
import UpdateLodgingProductRoom from '../apis/LodgingAPIContent/LodgingProductAPI/UpdateLodingProductRoom';

export default class GuideSideBar extends React.Component {

    constructor(props){
        super(props);
        this.state = (
            {
                elementNameValue:""
            }
        )
    }

    componentDidMount() {
        $('.sub-menu ul').hide();
        $("a").click(function () {
            $("a").removeClass('active');
            $(this).addClass('active');
            $(this).parent(".sub-menu").children("ul").slideToggle("100");
            $(this).find(".right").toggleClass("fa-caret-up fa-caret-down");
        });
    }

    render() {
        return(
            <div id="guideSideBar">
            <nav className="animated bounceInDown" onMouseDown={this.props.getElementNameValue}>
                <ul>
                    <li><a name="guides-section-01">Intro</a></li>
                    <li><a name="guides-section-02">HMAC Signature 생성</a></li>
                    <li><a name="guides-section-03">API key 발급받기</a></li>
                    <li className='sub-menu'><a name="guides-section-04">티켓 상품 API
                        <div className='fa fa-caret-down right'></div></a>
                        <ul>
                            <li className='sub-menu'><a>상품 API
                                <div className='fa fa-caret-down right'></div>
                            </a>
                                <ul>
                                    <li><a name={"create-ticket-product"}>상품 등록</a></li>
                                    <li><a name={"create-ticket-product-item"}>옵션 등록</a></li>
                                    <li><a name={"delete-ticket-product"}>상품 삭제</a></li>
                                    <li><a name={"delete-ticket-product-item"}>옵션 삭제</a></li>
                                    <li><a name={"update-ticket-product"}>상품 수정</a></li>
                                    <li><a name={"update-ticket-product-item"}>옵션 수정</a></li>
                                    <li><a name={"start-to-sell-ticket-product"}>상품 판매 시작</a></li>
                                    <li><a name={"stop-to-sell-ticket-product"}>상품 판매 중지</a></li>
                                    <li><a name={"view-single-ticket-product"}>단일 조회</a></li>
                                    <li><a name={"view-ticket-product-by-page"}>목록 조회</a></li>
                                    <li><a name="update-ticket-inventory-by-date">요금/수량 </a></li>
                                    <li><a name="view-ticket-item-inventories">재고 조회</a></li>
                                </ul>
                            </li>
                            <li className={"sub-menu"}><a>예약/취소 API
                                <div className='fa fa-caret-down right'></div></a>
                                <ul>
                                    <li className='sub-menu'><a>버전 1
                                        <div className='fa fa-caret-down right'></div>
                                    </a>
                                        <ul>
                                            <li><a name={"ticket-usage-processing"}>티켓 사용 처리</a></li>
                                            <li><a name={"mutiple-ticket-usage-processing"}>다수 티켓 사용 처리</a></li>
                                            <li><a name={"ticket-free-processing"}>티켓 미사용 처리</a></li>
                                            <li><a name={"mutiple-ticket-unused-processing"}>다수 티켓 미사용 처리</a></li>
                                            <li><a name={"ticket-buyer-info-lookup"}>티켓 구매자 정보 조회</a></li>
                                            <li><a name={"view-ticket-details"}>티켓 상세 정보 조회</a></li>
                                            <li><a name={"view-mutiple-ticket-details"}>다수 티켓 상세 정보 조회</a></li>
                                            {/*<li><a name={"ticket-refund-request"}>티켓 환불 요청 API</a></li>*/}
                                            {/*<li><a name={"ticket-refund-request-list"}>티켓 환불 요청 리스트 조회 API</a></li>*/}
                                        </ul>
                                    </li>
                                    <li className='sub-menu'><a>버전 2
                                        <div className='fa fa-caret-down right'></div>
                                    </a>
                                        <ul>
                                            <li><a name={"view-ticket-buyer-info-V2API"}>티켓 구매자 정보 조회</a></li>
                                            <li><a name={"travel-ticket-buyer-info-V1API"}>여행 상품별 구매자 정보 조회</a></li>
                                            <li><a name={"view-canceled-ticket-info-V2"}>취소 완료 티켓 정보 조회</a></li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li className='sub-menu'><a name="guides-section-05">패키지/항공권 상품 API
                        <div className='fa fa-caret-down right'></div></a>
                        <ul>
                            <li className = 'sub-menu'>
                                <a name="guides-section-05">상품 API<div className='fa fa-caret-down right'></div></a>
                                <ul>
                                    {/*<li className='sub-menu'><a>버전 1<div className='fa fa-caret-down right'></div></a>*/}
                                    {/*    <ul>*/}
                                            {/*<li><a name="create-tour-product">상품 등록</a></li>*/}
                                            {/*<li><a name="update-tour-product">상품 수정</a></li>*/}
                                            {/*<li><a name="delete-tour-product">상품 삭제</a></li>*/}
                                            {/*<li><a name="view-tour-product-list">목록 조회</a></li>*/}
                                            {/*<li><a name="view-single-tour-product">단일 조회</a></li>*/}
                                            {/*<li><a name="create-tour-product-items">옵션 등록</a></li>*/}
                                            {/*<li><a name="update-tour-product-item">옵션 수정</a></li>*/}
                                            {/*<li><a name="delete-tour-product-item">옵션 삭제</a></li>*/}
                                            {/*<li><a name="update-tour-inventory-by-date">요금/수량 </a></li>*/}
                                            {/*<li><a name="view-tour-item-inventories">재고 조회</a></li>*/}
                                            {/*<li><a name="view-tour-product-history">View Tour Product History</a></li>*/}
                                        {/*</ul>*/}
                                    {/*</li>*/}
                                    {/*<li className='sub-menu'><a>버전 2<div className='fa fa-caret-down right'></div></a>*/}
                                    {/*    <ul>*/}
                                            <li><a name="create-tour-product-V2API">상품 등록</a></li>
                                            <li><a name="update-tour-product-V2API">상품 수정</a></li>
                                            <li><a name="delete-tour-product">상품 삭제</a></li>
                                            <li><a name="delete-tour-product-item">옵션 삭제</a></li>
                                            <li><a name="view-tour-product-list">목록 조회</a></li>
                                            <li><a name="view-single-tour-product">단일 조회</a></li>
                                            <li><a name="update-tour-inventory-by-date-V2API">요금/수량</a></li>
                                            <li><a name="view-tour-inventories-V2API">재고 조회</a></li>
                                        {/*</ul>*/}
                                    {/*</li>*/}
                                </ul>
                            </li>
                        </ul>
                    </li>
                    <li className = 'sub-menu'><a name="guides-section-06">예약/취소 API
                        <div className='fa fa-caret-down right'></div></a>
                            <ul>
                                <li><a name="view-reservation-list">예약 목록 조회</a></li>
                                <li><a name="view-single-order-reservation">예약 단일 조회</a></li>
                                <li><a name="view-confirm-reservation">예약 확정</a></li>
                                <li><a name="view-reject-reservation">예약 불가</a></li>
                                <li><a name="view-approval-cancellation">취소 승인</a></li>
                                <li><a name="view-reservation-manage-history">주문 상태 이력 조회</a></li>
                            </ul>
                        {/*</li>*/}
                    </li>
                    <li className = 'sub-menu'><a name="guides-section-08">숙박 API
                        <div className='fa fa-caret-down right'></div></a>
                        <ul>
                            <li><a name="create-lodging-products">상품 등록</a></li>
                            <li><a name="create-lodging-product-rooms">룸 생성</a></li>
                            <li><a name="create-lodging-product-rate-plans">숙박 요금제 생성</a></li>
                            <li><a name="delete-lodging-product">숙박 상품 삭제</a></li>
                            <li><a name="delete-lodging-rate-plan">요금제 삭제</a></li>
                            <li><a name="update-lodging-product-products">숙박 상품 업데이트</a></li>
                            <li><a name="update-lodging-product-room">룸 업데이트</a></li>
                            <li><a name="update-lodging-product-rate-plan">요금제 업데이트</a></li>
                            <li><a name="get-lodging-product-info">숙박 상품 보기</a></li>
                            <li><a name="update-lodging-inventory">요금/수량</a></li>
                        </ul>
                        {/*</li>*/}
                    </li>
                    {/*<li><a name="guides-section-06">FAQs</a></li>*/}
                </ul>
            </nav>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./travel-developers-interface/src/main/client/component/GuideSideBar.jsx